<template>
  <div class="tab-container">
    <div
      class="tab"
      :class="{ active: isActive(tab, index) }"
      v-for="(tab, index) in tabsArr"
      :key="useTabKey ? tab : index"
      :style="widthComputed"
      @click="activeTab(tab, index)"
    >
      <span>{{ tab }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tabsArr: {
        type: Array,
      },
      useTabKey: {
        type: Boolean,
        default: false,
      },
      initialTab: {
        type: [Number, String],
        default: 0,
      },
      selected: Number,
    },
    data() {
      return {
        active: this.initialTab,
      };
    },
    created() {
      this.$emit('active', this.active);
    },
    computed: {
      widthComputed() {
        const width = 100 / this.tabsArr.length;
        return `width: ${width}%`;
      },
    },
    methods: {
      activeTab(tab, index) {
        this.active = this.useTabKey ? tab : index;
        this.$emit('active', this.active);
      },
      isActive(tab, index) {
        return this.useTabKey ? this.active === tab : this.active === index;
      },
    },
    watch: {
      initialTab(newVal) {
        this.active = newVal;
        this.$emit('active', this.active); // Optional: Re-emit for sync
      },
      selected(val) {
        if (this.useTabKey) {
          this.active = val;
        } else if (val === 0 || val === 1) {
          this.active = val;
        }
      },
    },
  };
</script>
<style scoped lang="scss">
  @import '@/assets/styles/variables.scss';

  .tab-container {
    width: 100%;
    border-bottom: 1px solid $input-border;
    display: flex;
    gap: 1.5rem;
    justify-content: start;
    align-items: flex-start;

    .tab {
      max-width: fit-content;
      padding: 0 0 1rem 0;
      cursor: pointer;
      color: $neutral-gray;
      font-size: 0.875rem;

      &.active {
        border-bottom: 1px solid $var-primary-main;
        color: $var-primary-main;
      }
    }
  }
</style>
